import React, {useState, useRef} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useTheme} from '@mui/styles'

import {connect} from 'react-redux'
import {createAccount, showAlert} from '../../actions'

import {formatError} from '../../utils'
import {useIsMounted} from '../../hooks'

import {ThreeDotProgress} from '../generics'

import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'



const cssStyles = props => ({
  root: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 150px;
    margin-top: 40px;
  `,
  buttonContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  `,
  button: css`
    width: 100%;
    height: 44px;
    background-color: ${props.theme.palette.primary.main};
    color: #fff;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 5px;
    font-size: 0.9rem;
    transition: opacity 0.3s;
    
    &:disabled {
      background-color: #000;
      opacity: 0.3;
    }
  `
})



const helperText = `
Your artist name can be the same as your username or something different and can contain spaces.
`



const AccountArtistForm = props => {

  const inputRef = useRef()

  const theme = useTheme()

  const styles = cssStyles({theme})

  const isMounted = useIsMounted()


  const [value, setValue] = useState('')

  const [errors, setErrors] = useState({})

  const [isSubmitting, setIsSubmitting] = useState(false)


  const {createAccount, callback, showAlert} = props


  function handleClick() {
    const name = inputRef.current.value.trim()
    const data = {name: name, type: 'artist'}

    setIsSubmitting(true)
    
    createAccount(data).then(response => {
      if (isMounted.current) {
        setIsSubmitting(false)
      }

      if (callback) {
        callback()
      }

      showAlert('Congratulations! Your artist account has been created', 'success')
    })
    .catch(error => {
      error = formatError(error)

      if (isMounted.current) {
        setIsSubmitting(false)
        setErrors(error.messages)
      }

      showAlert('There are errors in your input', 'error')
    })
  }



  function handleChange(e) {
    setValue(e.target.value)
  }



  return (
    <div css={styles.root}> 
      <TextField
        fullWidth
        label='Artist Name'
        variant='filled'
        inputRef={inputRef}
        onChange={handleChange}
        error={Boolean(errors.name)}
        helperText={errors.name || helperText}
      />

      <div css={styles.buttonContainer}>
        <Button css={styles.button} onClick={handleClick} disabled={isSubmitting || value === ''}>
          {isSubmitting ? <ThreeDotProgress color='#fff' radius={5} /> : 'Create'}
        </Button>
      </div>
    </div>
  )
}


export default connect(null, {createAccount, showAlert})(AccountArtistForm)


